import { render, staticRenderFns } from "./centre.vue?vue&type=template&id=04afbb94&"
import script from "./centre.vue?vue&type=script&lang=js&"
export * from "./centre.vue?vue&type=script&lang=js&"
import style0 from "./centre.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports